import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { renderStandardPictureElement } from "../../../../utils";
import {
    renderPageTemplate,
    renderPageWithMarginalColumnTemplate,
    renderPageWithMarginalColumnFullWidthTemplate,
    renderPageWithSidebarTemplate,
} from "../../../../utils";

export default {
    title: "Website/Page Templates/Integration Examples/Grid",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const Template = () => {
    return html`
        <div class="ux-t-container-full">
            <div class="ux-row ux-u-mb-fluid-m">
                <div class="ux-col">
                    ${renderStandardPictureElement({
                        width: 1600,
                        height: 500,
                    })}
                </div>
            </div>
        </div>
        <div class="ux-t-container">
            <div class="ux-row ux-u-mb-fluid-s">
                <div class="ux-col">
                    <h1
                        class="ux-text-headline ux-text-headline--giant ux-u-text-align--center"
                    >
                        Trumpf Grid Template
                    </h1>
                </div>
            </div>
            <div class="ux-row ux-u-mb-fluid-s">
                <div class="ux-col">
                    <img
                        src="https://www.trumpf.com/filestorage/TRUMPF_Master/_processed_/f/1/csm_Lightning-Rod-in-Action_d99ddd20e0.jpg"
                    />
                </div>
            </div>
            <div class="ux-row ux-u-mb-fluid-s">
                <div
                    class="ux-col ux-col-md-10 ux-u-offset-md-1 ux-u-text-align--center"
                >
                    <h2 class="ux-text-headline ux-text-headline--big">
                        Lorem Ipsum Headline
                    </h2>
                    <p>
                        Kontinuierliche Verbesserung überlassen wir nicht dem
                        Zufall, sondern gehen sie methodisch an. In der Praxis
                        initiieren wir mit den Schritten
                        Planen-Ausführen-Überprüfen-Anpassen (Plan-Do-Check-Act)
                        immer wieder aufs Neue, dass wir besser werden. Das
                        geschieht nicht von „oben herab“, sondern „am Ort des
                        Geschehens“ gemeinsam mit den Beteiligten.
                    </p>
                </div>
            </div>
            <div class="ux-row ux-u-mb-fluid-s">
                <div class="ux-col ux-col-md-10 ux-u-offset-md-1">
                    <ux-accordion>
                        <span slot="title"
                            >Lorem ipsum dolor sit amet, consetetur
                            sadipscing</span
                        >
                        <ul class="ux-list ux-u-margin-horizontal-10">
                            <li>List item 1 <ux-icon name="info"></ux-icon></li>
                            <li>List item 2</li>
                            <li>List item 3</li>
                        </ul>
                    </ux-accordion>
                    <ux-accordion>
                        <span slot="title"
                            >Lorem ipsum dolor sit amet, consetetur
                            sadipscing</span
                        >
                        <ul class="ux-list ux-u-margin-horizontal-10">
                            <li>List item 1 <ux-icon name="info"></ux-icon></li>
                            <li>List item 2</li>
                            <li>List item 3</li>
                        </ul>
                    </ux-accordion>
                    <ux-accordion>
                        <span slot="title"
                            >Lorem ipsum dolor sit amet, consetetur
                            sadipscing</span
                        >
                        <ul class="ux-list ux-u-margin-horizontal-10">
                            <li>List item 1 <ux-icon name="info"></ux-icon></li>
                            <li>List item 2</li>
                            <li>List item 3</li>
                        </ul>
                    </ux-accordion>
                </div>
            </div>
            <div class="ux-row ux-u-mb-fluid-s">
                <div class="ux-col">
                    <div class="ux-row">
                        <div
                            class="ux-col-12 ux-col-md-4 ux-u-mb-xs ux-u-mb-md-zero"
                        >
                            <img
                                src="https://www.trumpf.com/filestorage/TRUMPF_Master/_processed_/f/1/csm_Lightning-Rod-in-Action_d99ddd20e0.jpg"
                            />
                        </div>
                        <div
                            class="ux-col-12 ux-col-md-4 ux-u-mb-xs ux-u-mb-md-zero"
                        >
                            <img
                                src="https://www.trumpf.com/filestorage/TRUMPF_Master/_processed_/f/1/csm_Lightning-Rod-in-Action_d99ddd20e0.jpg"
                            />
                        </div>
                        <div class="ux-col-12 ux-col-md-4">
                            <img
                                src="https://www.trumpf.com/filestorage/TRUMPF_Master/_processed_/f/1/csm_Lightning-Rod-in-Action_d99ddd20e0.jpg"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="ux-row ux-u-mb-fluid-m">
                <div class="ux-col ux-col-md-10 ux-u-offset-md-1">
                    <div
                        class="block block-download block-first wrap-link is-linkHover wrap-link--isInitialized"
                    >
                        <div class="block-wrapper">
                            <div class="block-download-image">
                                <div class="block-download-image-coverWrapper">
                                    <div class="block-download-image-wrap">
                                        <img
                                            src="https://www.trumpf.com/filestorage/TRUMPF_Master/_processed_/f/1/csm_Lightning-Rod-in-Action_d99ddd20e0.jpg"
                                            width="100"
                                            height="140"
                                            alt=""
                                            title="DQS Certificate"
                                        />
                                        <div
                                            class="suffix-info"
                                            style="width: 79px;"
                                        >
                                            <div class="text-small ">
                                                <p>pdf</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="block-content"
                                data-sameheight="item"
                                data-sameheight-top="30"
                            >
                                <div class="block-download-date">
                                    <div class="text-medium ">31.03.2023</div>
                                </div>
                                <div class="block-download-size">
                                    <div class="text-medium u-uppercase">
                                        175 KB
                                    </div>
                                </div>
                                <div class="text-normal-bold">
                                    Zertifizierung nach DIN EN ISO 9001
                                </div>
                                <div class="text-medium ">
                                    <p>
                                        Bereits seit 1996 wird der TRUMPF
                                        Qualitätsstandard in den produzierenden
                                        TRUMPF Gesellschaften regelmäßig nach
                                        DIN EN ISO 9001 zertifiziert. Dies dient
                                        zum einen zur Sicherung der
                                        Marktposition gegenüber Wettwerbern aber
                                        auch zur ständigen Optimierung der
                                        Geschäftsprozesse.
                                    </p>
                                </div>
                            </div>
                            <div class="block-button">
                                <a
                                    href="/filestorage/TRUMPF_Master/Corporate/Quality/Zertifikat_ISO_9001_TRUMPF_Gruppe.pdf"
                                    class="btn btn-iconOnly "
                                    target="_blank"
                                >
                                    <i
                                        class="icon-download"
                                        style="background-image: none;"
                                    >
                                        <svg
                                            data-name="Ebene 1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 17 10.46"
                                        >
                                            <path
                                                d="M8.56 5.66l.71-.71L13.52.71 12.81 0 8.56 4.24 4.32 0l-.7.71 4.24 4.24.7.71zM16.02 6.46v3.02H.98V6.46H0v4h17v-4h-.98z"
                                            ></path>
                                        </svg>
                                    </i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ux-row ux-u-mb-fluid-s">
                <div class="ux-col">
                    <div class="ux-row ux-u-flex-jc-between">
                        <div class="ux-col">
                            <a href="#" class="ux-button" title="back">
                                <ux-icon name="chevron-left"></ux-icon> Zurück
                            </a>
                        </div>
                        <div class="ux-col ux-u-d-flex ux-u-flex-jc-end">
                            <ux-iws-async-toggle-button
                                class="ux-button ux-u-px-zero ux-u-px-md-s"
                                off=""
                            >
                                <span slot="on">
                                    <span class="ux-u-d-none ux-u-d-md-inline"
                                        >Favorit</span
                                    >
                                    <ux-icon
                                        name="bookmark"
                                        filled=""
                                    ></ux-icon>
                                </span>
                                <span slot="off">
                                    <span class="ux-u-d-none ux-u-d-md-inline"
                                        >Favorisieren</span
                                    >
                                    <ux-icon name="bookmark"></ux-icon>
                                </span>
                            </ux-iws-async-toggle-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ux-row ux-u-mb-fluid-s">
                <div class="ux-col">
                    <div class="ux-row">
                        <div class="ux-col-12 ux-col-md-5 ux-u-mb-m">
                            ${renderStandardPictureElement({
                                width: 708,
                                height: 472,
                            })}
                        </div>
                        <div class="ux-col-12 ux-col-md-7">
                            <div class="ux-info-box">
                                <div class="ux-info-box__intro">
                                    <h2
                                        class="ux-text-headline ux-text-headline--big"
                                    >
                                        User machine name
                                    </h2>
                                </div>
                                <div class="ux-row ux-u-mb-m">
                                    <div
                                        class="ux-col-12 ux-col-md-6 ux-u-mb-m"
                                    >
                                        <div
                                            class="ux-info-box__headline ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-mb-xxs"
                                        >
                                            Latest delivered version
                                        </div>
                                        <div
                                            class="ux-info-box__text ux-text-normal"
                                        >
                                            11.12.0
                                        </div>
                                    </div>
                                    <div
                                        class="ux-col-12 ux-col-md-6 ux-u-mb-m"
                                    >
                                        <div
                                            class="ux-info-box__headline ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-mb-xxs"
                                        >
                                            Latest available version
                                        </div>
                                        <div
                                            class="ux-info-box__text ux-text-normal"
                                        >
                                            13.16.22
                                        </div>
                                        <div
                                            class="ux-info-box__text ux-text-tiny"
                                        >
                                            Released on 25.02.22
                                        </div>
                                    </div>
                                    <div
                                        class="ux-col-12 ux-col-md-6 ux-u-mb-m"
                                    >
                                        <div
                                            class="ux-info-box__headline ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-mb-xxs"
                                        >
                                            Service Agreement Status
                                        </div>
                                        <div
                                            class="ux-text-status ux-text-status--green"
                                        >
                                            <ux-icon
                                                name="circle-filled"
                                            ></ux-icon>
                                            Active
                                        </div>
                                    </div>
                                    <div
                                        class="ux-col-12 ux-col-md-6 ux-u-mb-m"
                                    >
                                        <div
                                            class="ux-info-box__headline ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-mb-xxs"
                                        >
                                            Contract Start
                                        </div>
                                        <div
                                            class="ux-info-box__text ux-text-normal"
                                        >
                                            17.01.2022
                                        </div>
                                    </div>
                                    <div class="ux-col-12 ux-col-md-6">
                                        <div
                                            class="ux-info-box__headline ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-mb-xxs"
                                        >
                                            Number of licenses
                                        </div>
                                        <div
                                            class="ux-info-box__text ux-text-normal"
                                        >
                                            3
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ux-row ux-u-mb-fluid-s">
                <div class="ux-col">
                    <ux-tab-container fix-to-top scroll-when-activated>
                        <ux-tab
                            name="Licenses"
                            tab-id="licenses-content"
                            class="ux-u-my-l"
                        >
                        </ux-tab>
                        <ux-tab
                            name="Downloads"
                            tab-id="downloads-content"
                            class="ux-u-my-l"
                        >
                        </ux-tab>
                        <ux-tab
                            name="Optionen"
                            tab-id="optionen-content"
                            class="ux-u-my-l"
                        >
                        </ux-tab>
                    </ux-tab-container>
                </div>
            </div>
            <div class="ux-row ux-u-mb-fluid-s">
                <div
                    class="ux-col ux-col-md-10 ux-u-offset-md-1 ux-u-text-align--center"
                >
                    <h2 class="ux-text-headline ux-text-headline--big">
                        Lorem Ipsum Headline
                    </h2>
                    <p>
                        Kontinuierliche Verbesserung überlassen wir nicht dem
                        Zufall, sondern gehen sie methodisch an. In der Praxis
                        initiieren wir mit den Schritten
                        Planen-Ausführen-Überprüfen-Anpassen (Plan-Do-Check-Act)
                        immer wieder aufs Neue, dass wir besser werden. Das
                        geschieht nicht von „oben herab“, sondern „am Ort des
                        Geschehens“ gemeinsam mit den Beteiligten.
                    </p>
                </div>
            </div>
            <div class="ux-row ux-u-mb-fluid-s">
                <div
                    class="ux-col ux-col-md-10 ux-u-offset-md-1 ux-u-text-align--center"
                >
                    <h3 class="ux-text-headline ux-text-headline--big">
                        todo: product highlight slider width should be
                        controlled by outer col width
                    </h3>
                </div>
            </div>
        </div>
        <div class="ux-t-container-full">
            <div class="ux-row ux-u-mb-fluid-s">
                <div class="ux-col">
                    <ux-iws-product-highlight-slider>
                        ${[1, 2, 3, 4, 5, 6, 7, 8, 9].map(
                            (i) => html`
                                <ux-slider-slide>
                                    <ux-iws-teaser-product-tile
                                        product-image-url="mock-assets/images/TruLaser-highlight.png"
                                        product-name="TruLaser${i == 1
                                            ? " HIGHLIGHT"
                                            : ""} 7000"
                                        product-desc="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua."
                                        eyecatcher="${i == 1 ? ".NEW" : ""}"
                                    >
                                        <a
                                            href="#"
                                            class="ux-text-link ux-iws-teaser-product-tile__link"
                                        >
                                            Zum Produkt
                                            <ux-icon name="arrow-small-right" />
                                        </a>
                                    </ux-iws-teaser-product-tile>
                                </ux-slider-slide>
                            `
                        )}
                    </ux-iws-product-highlight-slider>
                </div>
            </div>
        </div>
        <div class="ux-t-container">
            <div class="ux-row ux-u-mb-fluid-s">
                <div class="ux-col">
                    <div class="ux-row">
                        <div
                            class="ux-col-12 ux-col-md-6 ux-u-mb-xs ux-u-mb-md-zero"
                        >
                            <ux-iws-teaser-image href="#" class="ux-u-shadow">
                                <div slot="image">
                                    <img
                                        src="https://www.trumpf.com/filestorage/TRUMPF_Master/_processed_/f/1/csm_Lightning-Rod-in-Action_d99ddd20e0.jpg"
                                    />
                                </div>
                                <div>
                                    <p
                                        class="ux-iws-teaser-image__title ux-text-headline ux-text-headline--small"
                                    >
                                        Nachhaltigkeit bei trumpf
                                    </p>
                                    <p>
                                        TRUMPF ist ein international tätiges
                                        Familienunternehmen. Lernen Sie unsere
                                        Mitglieder des Vorstands der
                                        Holding-Gesellschaft kennen.
                                    </p>
                                </div>
                            </ux-iws-teaser-image>
                        </div>
                        <div class="ux-col-12 ux-col-md-6 ">
                            <ux-iws-teaser-image href="#" class="ux-u-shadow">
                                <div slot="image">
                                    <img
                                        src="https://www.trumpf.com/filestorage/TRUMPF_Master/_processed_/f/1/csm_Lightning-Rod-in-Action_d99ddd20e0.jpg"
                                    />
                                </div>
                                <div>
                                    <p
                                        class="ux-iws-teaser-image__title ux-text-headline ux-text-headline--small"
                                    >
                                        Nachhaltigkeit bei trumpf
                                    </p>
                                    <p>
                                        TRUMPF ist ein international tätiges
                                        Familienunternehmen. Lernen Sie unsere
                                        Mitglieder des Vorstands der
                                        Holding-Gesellschaft kennen.
                                    </p>
                                </div>
                            </ux-iws-teaser-image>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
};

export const Default = () => renderPageTemplate(() => Template());
export const MarginalColumn = () =>
    renderPageWithMarginalColumnTemplate(() => Template());
export const MarginalColumnFullWidth = () =>
    renderPageWithMarginalColumnFullWidthTemplate(() => Template());
export const Sidebar = () => renderPageWithSidebarTemplate(() => Template());
